import { render, staticRenderFns } from "./WfDevComplaintForm.vue?vue&type=template&id=79aa6492&"
import script from "./WfDevComplaintForm.vue?vue&type=script&lang=js&"
export * from "./WfDevComplaintForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports